import React from 'react'

const ButtonShimmer = () => {
  return (
    <button className="animate-pulse text-primary bg-white focus:outline-none rounded-lg border border-primary text-sm font-medium px-5 py-2.5 flex items-center justify-between w-[176px]" type="button">
    <span className="break-words" style={{
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "1",
        overflow: "hidden"
    }}>
        <div className="w-24 h-4 bg-gray-200"></div>
    </span>
    <div className="w-4 h-4 ml-2.5 bg-gray-200"></div>
</button>
  )
}

export default ButtonShimmer